'use client';
import React from 'react';
import Button from '@mui/material/Button';
import { PAGE_PATHS } from '../../../constants/constants';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Divider,
  Stack,
  Typography
} from '@mui/material';
import SSOButtons from '../../(main)/(theme)/signin/ssoButtons';
import { useUser } from '@/utils/supabase/useUser';
import SignupDetailsForm from './SignupDetailsForm';

const CreateAccountCard = ({
  nextPath,
  redirectURL
}: {
  nextPath?: string;
  redirectURL?: string;
}) => {
  const { user } = useUser();

  return (
    <Card
      sx={(theme) => ({
        opacity: user ? 0.6 : 1,
        border: !user ? '1px solid' : null,
        borderColor: !user ? theme.palette.primary.main : undefined
      })}
    >
      <CardHeader
        title={
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Typography
              variant='h2'
              sx={{
                backgroundColor: '#F4A71C',
                borderRadius: '50%',
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              1
            </Typography>
            <Box>
              <Typography variant='h1' component='span'>
                {user ? 'Account Created' : 'Create an Account'}
              </Typography>
              {user && (
                <>
                  <Typography variant='body1'>Email Verified:</Typography>
                  <Typography variant='h4'>{user.email}</Typography>
                </>
              )}
            </Box>
          </Box>
        }
      />
      <Collapse in={!user} timeout='auto' unmountOnExit>
        <CardContent>
          <Stack useFlexGap textAlign='center'>
            <SSOButtons
              nextPath={nextPath ?? undefined}
              redirectURL={redirectURL ?? undefined}
            />
            <Divider>OR CONTINUE WITH EMAIL</Divider>
            <SignupDetailsForm />
            <Divider>Already have an account?</Divider>
            <Button
              variant='text'
              href={
                PAGE_PATHS.signin +
                (nextPath ? `?next=${encodeURIComponent(nextPath)}` : '')
              }
              color='secondary'
              endIcon={<ArrowForwardOutlinedIcon />}
            >
              SIGN IN INSTEAD{' '}
            </Button>
          </Stack>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default CreateAccountCard;
